<template>
    <sections>
        <section-text heading="Clients" content="<article-clients />"></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Clients | ' + $config.public.siteName,
    description:
        'Freeway Recruitment currently have two key branches in the north of England located in Leeds and Manchester.',
    index: true,
});
</script>
